import { render, staticRenderFns } from "./FullWidthTitle.vue?vue&type=template&id=0bf5a2e1&scoped=true&"
import script from "./FullWidthTitle.vue?vue&type=script&lang=ts&"
export * from "./FullWidthTitle.vue?vue&type=script&lang=ts&"
import style0 from "./FullWidthTitle.vue?vue&type=style&index=0&id=0bf5a2e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5a2e1",
  null
  
)

export default component.exports